function copyButton() {
    return {
        componentName: 'copyButton',
        baseStyle: {
            cursor: 'pointer'
        }
    };
}

export { copyButton as default };
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY29weUJ1dHRvbi5qcyIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vc3JjL3RoZW1lL2NvbXBvbmVudHMvY29weUJ1dHRvbi50cyJdLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgeyBDb21wb25lbnRTdHlsZSB9IGZyb20gJy4uL3R5cGVzJztcblxuZXhwb3J0IGRlZmF1bHQgZnVuY3Rpb24gY29weUJ1dHRvbigpOiBDb21wb25lbnRTdHlsZSB7XG4gIHJldHVybiB7XG4gICAgY29tcG9uZW50TmFtZTogJ2NvcHlCdXR0b24nLFxuICAgIGJhc2VTdHlsZToge1xuICAgICAgY3Vyc29yOiAncG9pbnRlcidcbiAgICB9XG4gIH07XG59XG4iXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBRWMsU0FBVSxVQUFVLEdBQUE7SUFDaEMsT0FBTztBQUNMLFFBQUEsYUFBYSxFQUFFLFlBQVk7QUFDM0IsUUFBQSxTQUFTLEVBQUU7QUFDVCxZQUFBLE1BQU0sRUFBRSxTQUFTO0FBQ2xCLFNBQUE7S0FDRixDQUFDO0FBQ0o7Ozs7In0=
